import React from 'react'
import { CircularProgress as MuiCircularProgress } from '@material-ui/core'
import styleOverride from './styleOverride'

interface CircularProgressProps {
  classes?: any
  color?: 'inherit' | 'primary' | 'secondary'
  disableShrink?: boolean
  size?: number | string
  thickness?: number
  value?: number
  variant?: 'determinate' | 'indeterminate' | 'static'
  className?: string | undefined
}

const CircularProgress = (props: CircularProgressProps) => {
  const { color,size,thickness,value, ...other } = props
  return <div className={styleOverride().root}>
      <MuiCircularProgress 
      color={color}
      size={size}
      variant={other.variant}
      disableShrink={other.disableShrink}
      value={value}
      thickness={thickness}
      classes={other.classes?other.classes:styleOverride()}
      className={other.className} />
    </div>
}

export default CircularProgress
